import React, { useEffect, useId } from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import PayPalCheckout from 'utils/PayPalCheckout';
import basketUtils from 'utils/Basket';

function PayPalButton({ isBopis }) {
    // Use React's useId() for SSR-safe unique IDs
    const id = useId();
    // Remove colons to make the ID CSS-selector-safe
    const containerId = `paypal-place-order-button-container-${id.replace(/:/g, '')}`;

    useEffect(() => {
        const isPickupOrder = isBopis || basketUtils.isPickup();
        PayPalCheckout.renderPayPalButton({ containerId, isBopis: isPickupOrder });

        return () => {
            PayPalCheckout.cleanupPayPalButton({ containerId });
        };
    }, [containerId, isBopis]);

    return <div id={containerId} />;
}

export default wrapFunctionalComponent(PayPalButton, 'PayPalButton');
